import React from "react";
import { ImageUploadWithPreview } from "components";
import { Controller, useForm } from "react-hook-form";

interface IItemPopup {
    onClose?: () => void;
    onConfirm?: (a: any) => void;
}
export default function Attachment({ onClose, onConfirm }: IItemPopup) {
    const {
        control,
        handleSubmit,
    } = useForm({ defaultValues: { files: null } });

    return (
        <div className="mx-auto bg-white rounded-lg ">
            <div className="content-modal p-4">
                <div>
                    <Controller
                        control={control}
                        name="files"
                        render={({ field }) => (
                            <ImageUploadWithPreview multiple={true} {...field} onPick={f => field.onChange(f)} />
                        )}
                    />

                </div>
            </div>
            <div className="flex justify-center gap-2 p-4">
                <button
                    onClick={onClose}
                    className="bg-gray-500 text-white px-4 py-1 rounded hover:bg-gray-600"
                >
                    Huỷ
                </button>
                {!!onConfirm && <button
                    onClick={() => handleSubmit(onConfirm)()}
                    className="bg-green-500 text-white px-4 py-1 rounded hover:bg-green-600"
                >
                    Xác nhận
                </button>}
            </div>
        </div>
    );
}
